import React from 'react';
import { Result } from 'antd';
import { Link } from 'react-router-dom';
import AccountLayout from '../../../layout/account/AccountLayout';

const JoinTeam = () => {
  return (
    <AccountLayout>
      <Result
        title="Vous avez été ajouté à une équipe"
        subTitle="Pour pouvoir y accéder, vous devez d'abord vous inscrire."
        extra={<Link to="/account/signup">{'M\'inscrire'}</Link>}
      />
    </AccountLayout>
  );
};

export default JoinTeam;
